import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/ui';

export const HomeRedirect: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading while checking authentication status
  if (loading) {
    return (
      <LoadingSpinner
        title="Loading GrowthBnk..."
        subtitle="Checking your authentication status"
        size="medium"
      />
    );
  }

  // Redirect based on authentication status
  return <Navigate to={isAuthenticated ? '/dashboard' : '/auth/login'} replace />;
};
